import createStore from "../common/store.js";
const store = createStore();
export const GlobalStoreProvider = store.Provider;
export const useGlobalStore = store.useStore;
